import React from "react"
import { Link, navigate } from "gatsby"
import { useTranslation } from "react-i18next"
import ArrowLeftIcon from "../../svg/arrow-left.inline.svg"
import ArrowRightIcon from "../../svg/arrow-right.inline.svg"
import Copyright from "../../components/copyright"

const SchoolFooterSection = props => {
  const school = props.school
  const schools = props.schools.sort((a, b) => a.name?.localeCompare(b.name))

  const currentIndex = schools.findIndex(s => s.id === school.id)
  const isLastSchool = school.id === schools[schools.length - 1].id
  const isFirstSchool = school.id === schools[0].id
  const previousSchoolSettings =
    schools[currentIndex - 1]?.dataContext?.settings || {}
  const previousSchool = schools[currentIndex - 1] || {}

  const nextSchoolSettings =
    schools[currentIndex + 1]?.dataContext?.settings || {}
  const nextSchool = schools[currentIndex + 1] || {}

  const { t, i18n } = useTranslation()
  const currentLang = i18n.language

  const onNextSchool = () => {
    if (isLastSchool) {
      return
    }
    const idToGo = schools[currentIndex + 1].resolvedPath

    if (school.isSummer) {
      navigate(`/${currentLang}/summer-schools/${idToGo}`)
    } else {
      navigate(`/${currentLang}/school/${idToGo}`)
    }
  }

  const onPrevSchool = () => {
    if (isFirstSchool) {
      return
    }
    const idToGo = schools[currentIndex - 1].resolvedPath
    if (school.isSummer) {
      navigate(`/${currentLang}/summer-schools/${idToGo}`)
    } else {
      navigate(`/${currentLang}/school/${idToGo}`)
    }
  }

  const determineSchoolType = currentSchool => {
    if (!currentSchool.isSummer) {
      return (
        <div className="prev-school nav-control-button">
          {t("school.feedback.prevSchool")}
        </div>
      )
    } else {
      return (
        <div className="prev-school nav-control-button">
          {t("school.feedback.prevOrg")}
        </div>
      )
    }
  }

  const lastSchoolClass = isLastSchool ? "col-12" : "col-lg-6"
  const firstSchoolClass = isFirstSchool ? "col-12" : "col-lg-6"

  return (
    <div className="bottom-block">
      <div className="about-us-wrapper other-schools-wrapper container justify-content-center">
        <div className="row w-100 prev-nex-wrapper d-flex justify-content-between">
          {!isFirstSchool ? (
            <div
              className={`curs-P p-6 d-flex flex-column justify-content-between previous-school-wrapper ${lastSchoolClass} mt-3`}
              style={{
                backgroundImage: `linear-gradient(rgba(11, 16, 32, 0.6) 0%, rgba(11, 16, 32, 0.6) 100%), url(${previousSchool.resolvedCroppedImageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
              onClick={onPrevSchool}
            >
              <div className="title-part">
                <div className="title">
                  {" "}
                  {previousSchool.schoolTypesResolved}{" "}
                  {previousSchool.ageMax && (
                    <>
                      · {previousSchool.ageMin}–{previousSchool.ageMax}{" "}
                      {t("school.years")}
                    </>
                  )}
                </div>
              </div>
              <div className="bot-part">
                <div className="school-info">
                  <div className="school-name">{previousSchool.name}</div>
                  <div className="school-location">
                    {previousSchool.settlement}{" "}
                    {previousSchool.regionResolved && (
                      <>· {previousSchool.regionResolved}</>
                    )}
                  </div>
                  <div className="previous-item-wrapper f-js f-ac curs-P">
                    <ArrowLeftIcon className="arrow_left" />

                    {determineSchoolType(school)}
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {!isLastSchool && (
            <div
              className={`curs-P p-6 d-flex flex-column justify-content-between ${firstSchoolClass} next-school-wrapper mt-3`}
              style={{
                backgroundImage: `linear-gradient(rgba(11, 16, 32, 0.6) 0%, rgba(11, 16, 32, 0.6) 100%), url(${nextSchool.resolvedCroppedImageUrl})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
              onClick={onNextSchool}
            >
              <div className="title-part f-je">
                <div className="title">
                  {nextSchool.schoolTypesResolved}{" "}
                  {nextSchool.ageMax && (
                    <>
                      · {nextSchool.ageMin}–{nextSchool.ageMax}{" "}
                      {t("school.years")}
                    </>
                  )}
                </div>
              </div>
              <div className="bot-part f-je">
                <div className="school-info">
                  <div className="school-name f-je">{nextSchool.name}</div>
                  <div className="school-location f-je">
                    {nextSchool.settlement}{" "}
                    {nextSchool.regionResolved && (
                      <>· {nextSchool.regionResolved}</>
                    )}
                  </div>
                  <div className="previous-item-wrapper f-je f-ac curs-P">
                    {!school.isSummer ? (
                      <div className="prev-school nav-control-button">
                        {t("school.feedback.nextSchool")}
                      </div>
                    ) : (
                      <div className="prev-school nav-control-button">
                        {t("school.feedback.nextOrg")}
                      </div>
                    )}
                    <ArrowRightIcon className="arrow_right" />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bottom-info-wrapper container pb-5">
        <div className="row">
          <div className="bottom-info-left-block col-lg-6 d-flex gap-3">
            <Copyright />
            <div className="">·</div>

            <Link to={`/${currentLang}/privacy`}>
              <div className="bottom-link">{t("school.footer.privacy")}</div>
            </Link>
            <div className="">·</div>
            <Link to={`/${currentLang}/terms`}>
              <div className="bottom-link terms">
                {t("school.footer.terms")}
              </div>
            </Link>
          </div>
          <div className="bottom-info-right-block col-lg-6 d-flex gap-3 justify-content-end">
            <a target="_blank" href="https://www.facebook.com/businesslinkkyiv">
              <div className="bottom-link">Facebook</div>
            </a>
            <div className="">·</div>
            <a
              target="_blank"
              href="https://www.instagram.com/businesslink.com.ua/"
            >
              <div className="bottom-link">Instagram</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SchoolFooterSection
